export function getFirstL(s: string, isCzech: boolean) {
    if (isCzech && s?.length > 1) {
        return s?.toLowerCase().startsWith('ch') ? 'Ch' : s.toUpperCase()?.[0]
    }
    return s?.toUpperCase()?.[0] || ''
}

export function shouldRenderFirstLetter(
    nameA: string,
    nameB: string,
    i: number,
    isCzech: boolean
) {
    const nameALetter = getFirstL(nameA, isCzech)
    const nameBLetter = getFirstL(nameB, isCzech)
    return i > 0 && nameALetter !== nameBLetter
}
